import { isFragment as isReactFragment } from 'react-is';
export default function isFragment(value) {
    return value.type === 'fragment' || isReactFragment(value);
}
